<app-redemption-point-list [pagePath]="'redemptionpoints'"></app-redemption-point-list>
